import ReactDOM from "react-dom";
import React, { useEffect, useRef, useState } from "react";

interface ITooltip {
  synonyms: string;
  parentRef?: HTMLParagraphElement | null;
}

const Tooltip = ({ parentRef, synonyms }: ITooltip) => {
  const refTooltip = useRef<HTMLDivElement | null>(null);

  const [dropdownPosition, setDropdownPosition] = useState({
    left: 0,
    top: 0
  });

  useEffect(() => {
    const scrollY = window.scrollY;
    const scrollX = window.scrollX;
    const ref = parentRef;

    if (ref) {
      const rect = ref.getBoundingClientRect();
      const rectTooltip = refTooltip?.current?.getBoundingClientRect();

      const tooltipWidth = (rectTooltip?.width || 0);
      const windowWidth = window.innerWidth;
      let direction: 'left' | 'right' = 'right';

      if (rect.left + tooltipWidth > windowWidth) {
        direction = 'left';
      }

      if (rect?.left && rect?.bottom) {
        setDropdownPosition({
          left: direction === 'right' ? rect.left + scrollX : rect.right + scrollX - tooltipWidth,
          top: rect.bottom + scrollY,
        });
      }
    }
  }, [parentRef]);

  const isOpacity = dropdownPosition.left && dropdownPosition.top;

  const inlineStyle: { [index: string]: string } = {
    zIndex: "999", 
    position: "absolute",
    opacity: isOpacity ? "1" : "0",
    left: `${dropdownPosition.left}px`,
    top: `${dropdownPosition.top + 15}px`,
  };

  return ReactDOM.createPortal(
    <div
      ref={refTooltip}
      style={inlineStyle}
      className="all-drugs-vocabulary__tooltip"
    >
      <p dangerouslySetInnerHTML={{ __html: synonyms }} />
    </div>,
    document.body
  );
};

export default Tooltip